// @ts-nocheck

import createReducer from '../../../utils/createReducer';
import { TUTO_NB_STEPS } from '../components/tuto/Steps';
import { GridMatchLengths } from '../types';
import type { UiState } from '../types';
import { GridsActionTypes } from '../types/actions';
import type {
  SetTutoStepAction,
  SetPoolNavigationAction,
  SetActivePoolsAction,
  SetRunningGridsAction,
} from '../types/actions';

export const initialState: UiState = {
  tutoStep: 0,
  poolNavigation: GridMatchLengths.SEVEN,
  activePools: null,
  runningGrids: null,
};

export const setTutoStep = (state: UiState, action: SetTutoStepAction): UiState => {
  const { step } = action.payload;
  if (step >= 0 && step < TUTO_NB_STEPS) {
    return {
      ...state,
      tutoStep: step,
    };
  }
  return state;
};

export const setPoolNavigation = (state: UiState, action: SetPoolNavigationAction): UiState => {
  const { type } = action.payload;
  return {
    ...state,
    poolNavigation: type,
  };
};

export const setActivePools = (state: UiState, action: SetActivePoolsAction): UiState => {
  const { activePools } = action.payload;
  return {
    ...state,
    activePools,
  };
};

export const setRunningGrids = (state: UiState, action: SetRunningGridsAction): UiState => {
  const { runningGrids } = action.payload;
  return {
    ...state,
    runningGrids,
  };
};

export default createReducer(initialState, {
  [GridsActionTypes.SET_TUTO_STEP]: setTutoStep,
  [GridsActionTypes.SET_POOL_NAVIGATION]: setPoolNavigation,
  [GridsActionTypes.SET_ACTIVE_POOLS]: setActivePools,
});
